"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Countries = Object.freeze({
  AR: {
    sufijo: 'ar',
    id: 1,
    nombre: 'Argentina'
  },
  EC: {
    sufijo: 'ec',
    id: 9,
    nombre: 'Ecuador'
  },
  PE: {
    sufijo: 'pe',
    id: 11,
    nombre: 'Perú'
  },
  VE: {
    sufijo: 've',
    id: 13,
    nombre: 'Venezuela'
  },
  MX: {
    sufijo: 'mx',
    id: 18,
    nombre: 'México'
  },
  PA: {
    sufijo: 'pa',
    id: 20,
    nombre: 'Panamá'
  },
  CL: {
    sufijo: 'cl',
    id: 1007,
    nombre: 'Chile'
  }
});